import Decimal from 'decimal.js';
export function getProportion(contractAmount, addedAmount) {
    try {
        const ca = new Decimal(contractAmount || 0);
        const aa = new Decimal(addedAmount || 0);
        if (ca.eq(0)) {
            return '';
        }
        const ratio = aa.div(ca);
        return ratio.times(100).toFixed(2) + '%'
    } catch (e) {
        return '';
    }
}